import { useState, useEffect } from "react";
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
import Network from "../../../utils/Network";
import { Urls } from "../../../utils/Constants";
import Loader from "../../common/Loader";
import ConfirmBbps from "../../common/modal/confirmbbps";
import ErrorSuccessModal from "../../common/modal/errorsuccessmodal";

export default function RefundPendigReport() {
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dmtData, setDmtData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [resultRptId, setResultRptId] = useState("");
  const [resultService, setResultService] = useState("");
  const [resultBeneAccount, setResultBeneAccount] = useState("");
  const [resultMob, setResultMob] = useState("");
  const [resultUTR, setResultUTR] = useState("");
  const [resultAmount, setResultAmount] = useState("");
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(0);
  const [isErrorFlag, setIsErrorFlag] = useState(0);
  const [showErrorSuccessModal, setShowErrorSuccessModal] = useState(0);
  const [modalMsg, setModalMsg] = useState("");
  
  const openConfirmModal = () => setShowConfirmPopUp(1);
  const closeConfirmModal = () => setShowConfirmPopUp(0);

  const openModal = (type) => {
    switch(type){
      case 'Error':
        setIsErrorFlag(1);
        setShowErrorSuccessModal(1);
      break;
      case 'Success':
        setIsErrorFlag(0);
        setShowErrorSuccessModal(1);
      break;
    }    
  };
  const closeModal = (type) => {
    if(type === 'Success' || type === 'Error'){
      setIsErrorFlag(0);
      setShowErrorSuccessModal(0);
    }
  };

  useEffect(() => {
    const todayDate = getDates();
    reportData(todayDate);
  }, [])
  
  const getDates = (selectedFromDate=null,selectedToDate=null) => {
        const today = new Date();
        if(selectedFromDate === null && selectedToDate === null){
        const todayDate = formatDate(today);
        setFromDate(todayDate);
        setToDate(todayDate);
        return todayDate;
        }else{
          return {selectedFromDate,selectedToDate};
        }
    };
  const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
  };

  const reportData = async(defaultDate=null,page=null) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      if(defaultDate !== null){
        formData.append("fromdate", defaultDate);
        formData.append("todate", defaultDate);
      }else{
        formData.append("fromdate", fromDate);
        formData.append("todate", toDate);
      }
      
      try {
        setLoading(true);
        let response = "";
        if(page === null){
          response = await Network.post(Urls.baseUrlPostLogin + '/report/refund-pending', formData);
        }else{
          response = await Network.post(Urls.baseUrlPostLogin + '/report/refund-pending?page='+page, formData);
        }
        if(response?.data?.status !== 'failure'){
          setDmtData(response.data.data);
          setLastPage(response.data.pagination.last_page);
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const fetchDMTReport = () => {
    getDates(fromDate,toDate);
    reportData();
  }
  const handleClickPaginate = (page) => {
    setCurrentPage(page);
    reportData(null,page);
  };
  const downloadReport = async(type) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("fromdate", fromDate);
      formData.append("todate", toDate);
      formData.append("type", type);
      try {
        setLoading(true);                
        const response = await Network.post(Urls.baseUrlPostLogin + '/report/refund-pending', formData);
        if(response?.data?.status !== 'failure'){
          openLinkInNewTab(response.data.url);
        }else{
          setModalMsg(response.data.message);
          openModal('Error');
        }
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const openLinkInNewTab = (url) => {
    window.open(url, '_blank');
  };
  const handleOnclick = async(orderId) => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("id", orderId);
      try {
          setLoading(true);                
          const response = await Network.post(Urls.baseUrlPostLogin + '/report/view-refund-pending', formData);
          if(response?.data?.status === 'success'){
            setResultRptId(response.data.data.report_id);
            setResultService(response.data.data.service);
            setResultBeneAccount(response.data.data.bene_account);
            setResultMob(response.data.data.mobile);
            setResultUTR(response.data.data.utr);
            setResultAmount(response.data.data.amount);
            openConfirmModal();
          }else{
            setModalMsg(response.data.message);
            openModal('Error');
          }
        } catch (err) {
          console.log('error', err);
        } finally {
          setLoading(false); // Hide loader
        }
  }
  const claimNow = async(mpin) => {
    let formData = new FormData();
    const localStorageDataStr = localStorage.getItem('token');
    const item = JSON.parse(localStorageDataStr);
    formData.append("api_token", item.token);
    formData.append("report_id", resultRptId);
    formData.append("mpin", mpin);
    try {
          setLoading(true);                
          const response = await Network.post(Urls.baseUrlPostLogin + '/report/refund-claim', formData);
          if(response?.data?.status === 'success'){
            setResultRptId("");
            setResultService("");
            setResultBeneAccount("");
            setResultMob("");
            setResultUTR("");
            setResultAmount("");
            setModalMsg(response.data.message);
            closeConfirmModal();
            openModal('Success');
          }else{
            setModalMsg(response.data.message);
            openModal('Error');
          }
        } catch (err) {
          console.log('error', err);
        } finally {
          setLoading(false); // Hide loader
        }
    
  }
  return (  
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
          <Loader /> :
          <main
            className="adminuiux-content has-sidebar"
          >
            {/*mt-4*/}
            <div className="container " id="main-content">
              <div className="row align-items-center">
              </div>
              {/* dashboard inner */}
              <div className="midde_cont">
                <div className="container-fluid">
                  <div className="row column_title">
                    <div className="col-md-12">
                      <div className="page_title d-sm-flex">
                        <h2>Refund Pending Report</h2>
                      </div>
                    </div>
                  </div>
                  <div className="row gutters mt-3">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="card rounded">
                        <div className="card-body">
                          <form
                            method="GET"
                            className=""
                          >
                            <div className="row gutters">
                              <div className="col-md-6">
                                <div className="">
                                  <div className="card-header p-2">Date</div>
                                  <div className="card-body">
                                    <div className="form-group">
                                      <label htmlFor="helperText">From Date</label>
                                      <input
                                        type="date"
                                        id="fromdate"                                        
                                        className="form-control hasDatepicker"
                                        placeholder="From"
                                        autoComplete="off"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                      />
                                    </div>
                                    {errors.fromDate && (
                                        <span className="error-message">
                                            {errors.fromDate}
                                        </span>
                                    )}
                                    <div className="form-group">
                                      <label htmlFor="helperText">To Date</label>
                                      <input
                                        type="date"
                                        id="todate"                                        
                                        className="form-control hasDatepicker"
                                        placeholder="To"
                                        autoComplete="off"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                      />
                                    </div>
                                    {errors.toDate && (
                                        <span className="error-message">
                                            {errors.toDate}
                                        </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <button type="button" className="btn btn-primary" onClick={fetchDMTReport}>
                                  Search
                                </button>&nbsp;
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  value="export"
                                  onClick={()=>downloadReport('excel')}
                                >
                                  Excel
                                </button>&nbsp;
                                <button
                                  type="button"
                                  className="btn btn-primary"                                  
                                  value="export"
                                  onClick={()=>downloadReport('csv')}
                                >
                                  Csv
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row match-height"
                    id="main_box"
                  >
                    <div className="col-12">
                      <div className="form-body">
                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="card adminuiux-card bd-0 shadow-base mt-2">
                              <div
                                className="card-header tx-medium bd-0 tx-white"
                                style={{ padding: "0.75rem 1.25rem" }}
                              >
                                Refund Pending Report
                              </div>
                              {/* card-header */}
                              <div className="card-body">
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Order ID</th>
                                        <th>Date</th>
                                        <th>Beneficiary Account</th>
                                        <th>Mobile</th>
                                        <th>Service</th>
                                        <th>UTR</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dmtData?.map((item)=>(
                                      <tr>
                                        <td>{item.order_id}</td>
                                        <td>{item.date}</td>
                                        <td>{item.bene_account}</td>
                                        <td>{item.mobile}</td>
                                        <td>{item.service}</td>
                                        <td>{item.utr}</td>
                                        <td>{item.amount}</td>
                                        <td>{item.status}</td>
                                        <td><button className="btn btn-primary btn-sm" data-toggle="tooltip" data-placement="top" title="Claim" onClick={() => handleOnclick(item.order_id)}>Claim</button></td>
                                      </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="mt-3 pull-right">
                                {Array.from({ length: lastPage }, (_, i) => i + 1).map((page) => (                                  
                                  <>
                                  <button
                                    key={page}
                                    onClick={()=>handleClickPaginate(page)}
                                    disabled={currentPage === page}
                                    className="btn btn-primary btn-sm"
                                  >
                                    {page}
                                  </button>
                                  &nbsp;
                                  </>
                                ))}
                                </div>
                              </div>
                            </div>
                            {/* card-body */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showConfirmPopUp === 1 &&
                <ConfirmBbps
                    title="Info Fetch"
                    service={resultService}
                    beneAccount={resultBeneAccount}
                    mobile={resultMob}
                    utr={resultUTR}
                    amount={resultAmount}
                    closeModal={closeConfirmModal}
                    claimNow={claimNow}
                    isBbps="2"
                />
              }
              {showErrorSuccessModal === 1 &&
                <ErrorSuccessModal
                  title={isErrorFlag === 0 ? 'Success' : 'Error'}
                  msg={modalMsg}
                  closeModal={closeModal}
                />
              }
            </div>
          </main>
        }
      </div>
    </>

  );
}